import { render, staticRenderFns } from "./TreatingPhysician.vue?vue&type=template&id=5c67fa50"
import script from "./TreatingPhysician.vue?vue&type=script&lang=js"
export * from "./TreatingPhysician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports